/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import SettingsComponent from '../components/SettingsComponent'
import { connect } from 'react-redux'
import { authConstants } from '../_constants'
import { userActions } from '../_actions'
import PropTypes from 'prop-types'
import { messageConstants } from '../_constants'
import { Growl } from 'primereact/growl'

function SettingsContainer({ getUserById, settingsEntry, isLoading, updateUser, checkOldAndNewPassword, checkOldAndNewPasswordMaptoolx, backOfficeMessage, clearAllMessages, updateUserMessage, getJustLookingUserById, justLookingEntry, maptoolxMessage }) {
  const growl = useRef()
  const justLookingId = 4
  const currentUserId = localStorage.getItem(authConstants.USERID)
  useEffect(() => {
    if (backOfficeMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Back Office Password Updated Successfully' })
      clearAllMessages()
    }
    if (backOfficeMessage === 'password-non-exist') {
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Old Password is In-Correct' })
      clearAllMessages()
    }
    if (maptoolxMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Back Office Password Updated Successfully' })
      clearAllMessages()
    }
    if (maptoolxMessage === 'password-non-exist') {
      // growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Old Password is In-Correct' })
      clearAllMessages()
    }
    if (updateUserMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Profile Details Updated Successfully' })
      clearAllMessages()
    }
    if (justLookingId === 4 && !isLoading && justLookingEntry == null) {
      getJustLookingUserById(justLookingId)
    }

  }, [settingsEntry, backOfficeMessage, updateUserMessage, justLookingEntry, maptoolxMessage])
  return (
    <div className="p-grid pageWrapper">
      <Growl ref={growl} />
      <SettingsComponent
        currentUserId={currentUserId}
        settingsEntry={settingsEntry}
        justLookingEntry={justLookingEntry}
        updateUser={updateUser}
        getUserById={getUserById}
        checkOldAndNewPassword={checkOldAndNewPassword}
        checkOldAndNewPasswordMaptoolx={checkOldAndNewPasswordMaptoolx}
      />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    settingsEntry: state.users.settingsEntry ? state.users.settingsEntry : null,
    justLookingEntry: state.users.justLookingEntry ? state.users.justLookingEntry : null,
    isLoading: state.users.isLoading,
    backOfficeMessage: state.users.backOfficeMessage,
    updateUserMessage: state.users.updateUserMessage,
    maptoolxMessage: state.users.maptoolxMessage,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUserById: (id) => dispatch(userActions.getUserById(id, false)),
    updateUser: (user, id) => dispatch(userActions.updateUser(user, id)),
    clearAllMessages: () => dispatch(userActions.clearAllMessages()),
    checkOldAndNewPassword: (currentUserIdComp, backOfficeOldPassword, backOfficeNewPassword) => dispatch(userActions.checkOldAndNewPassword(currentUserIdComp, backOfficeOldPassword, backOfficeNewPassword)),
    checkOldAndNewPasswordMaptoolx: (maptoolxFixedId, maptoolxUserName, maptoolxOldPassword, maptoolxNewPassword) => dispatch(userActions.checkOldAndNewPasswordMaptoolx(maptoolxFixedId, maptoolxUserName, maptoolxOldPassword, maptoolxNewPassword)),
    getJustLookingUserById: (id) => dispatch(userActions.getJustLookingUserById(id)),
  }
}
SettingsContainer.propTypes = {
  getUserById: PropTypes.func,
  settingsEntry: PropTypes.object,
  isLoading: PropTypes.bool,
  updateUser: PropTypes.func,
  checkOldAndNewPassword: PropTypes.func,
  backOfficeMessage: PropTypes.string,
  clearAllMessages: PropTypes.func,
  updateUserMessage: PropTypes.string,
  getJustLookingUserById: PropTypes.func,
  justLookingEntry: PropTypes.object,
  checkOldAndNewPasswordMaptoolx: PropTypes.func,
  maptoolxMessage: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer)
